import { z } from 'zod';
import { optionalE164PhoneSchema } from './phone';

export const eoiFormSchema = z.object({
  experienceLevel: z.enum(['beginner', 'intermediate', 'advanced']),
  goals: z.string().max(5000).optional(),
  availability: z.string().max(5000).optional(),
  message: z.string().max(5000).optional(),
});

export type EOIFormData = z.infer<typeof eoiFormSchema>;

export const eoiSubmitRequestSchema = eoiFormSchema.extend({
  academyId: z.string().uuid(),
  lessonId: z.string().uuid(),
  studentId: z.string().uuid(),
});

export type EoiSubmitRequest = z.infer<typeof eoiSubmitRequestSchema>;

/** Public guest EOI (no account) — guardian contact + player name */
export const eoiGuestSubmitRequestSchema = eoiFormSchema.extend({
  academyId: z.string().uuid(),
  lessonId: z.string().uuid(),
  guestContactEmail: z.string().email().max(320),
  guardianFirstName: z.string().min(1).max(100),
  guardianLastName: z.string().min(1).max(100),
  guardianPhone: optionalE164PhoneSchema,
  studentFirstName: z.string().min(1).max(100),
  studentLastName: z.string().min(1).max(100),
});

export type EoiGuestSubmitRequest = z.infer<typeof eoiGuestSubmitRequestSchema>;
